import webinars, { WebinarsListParams } from "@/getinfo-api/webinars";
import { Webinar as IWebinar } from "@/api/models/webinar";
import { WebinarList as IWebinarList } from "@/api/models/webinar-list";

export default {
  namespaced: true,
  state: {
    listenerWebinars: [] as Array<IWebinar>,
    listenerWebinarsCount: 0
  },
  actions: {
    async GET_WEBINARS(ctx: any, searchParams: WebinarsListParams) {
      let response = await webinars(searchParams);
      ctx.commit("SET_WEBINARS", response.data);
    }
  },
  mutations: {
    SET_WEBINARS(state: any, webinarsList: IWebinarList) {
      state.listenerWebinars = [
        ...state.listenerWebinars,
        ...webinarsList.webinars
      ];
      state.listenerWebinarsCount = webinarsList.count;
    },
    CLEAR(state: any) {
      state.listenerWebinars = [];
      state.listenerWebinarsCount = 0;
    }
  },
  getters: {
    LISTENER_WEBINARS(state: any): Array<IWebinar> {
      return state.listenerWebinars;
    },
    LISTENER_WEBINARS_COUNT(state: any): number {
      return state.listenerWebinarsCount;
    }
  }
};
